import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext<{
  error: string | undefined;
  setError: (error: string | undefined) => void;
}>({
  error: undefined,
  setError: () => {},
});

export const useErrorContext = () => useContext(ErrorContext);

export function ErrorContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [error, setError] = useState<string>();
  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  );
}
